import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  buscarProcesso,
  buscarSituacoes,
  buscarResponsaveis,
  buscarAlegacoes,
  buscarFases,
  limparPesquisa,
  carregaAlegacoesFase
} from "./actions";
import { exibirMensagem, fecharMensagem } from "componentes/mensagem/actions";
import {
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';

import Pagina from 'componentes/Pagina';
import PesquisaProcessosForm from 'componentes/PesquisaProcessosForm';
import ListagemProcessos from 'componentes/ListagemProcessos';


class PesquisaProcesso extends Component {
  componentDidMount() {
    this.props.buscarSituacoes();
    this.props.buscarResponsaveis();
    this.props.buscarAlegacoes();
    this.props.buscarFases();
  }

  render() {
    const titulo = "Pesquisar Processo";
    return (

      <Pagina title={titulo} breadcrumbs={[{ name: titulo, active: true }]}>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <PesquisaProcessosForm {...this.props} />
              </CardBody>
            </Card >
          </Col>

          {
            this.props.processos.length > 0 &&
            <Col>
              <ListagemProcessos {...this.props} />
            </Col>
          }
        </Row>

      </Pagina>

    );
  };

}
const mapStateToProps = state => ({
  processos: state.pesquisaprocesso.processos,
  situacoes: state.pesquisaprocesso.situacoes,
  responsaveis: state.pesquisaprocesso.responsaveis,
  alegacoes: state.pesquisaprocesso.alegacoes,
  fases: state.pesquisaprocesso.fases,

  mensagem: state.processo.mensagem

})


const mapDispatchToProps = dispatch => bindActionCreators({
  buscarProcesso,
  exibirMensagem,
  buscarSituacoes,
  buscarResponsaveis,
  buscarAlegacoes,
  buscarFases,
  limparPesquisa,
  carregaAlegacoesFase,
  fecharMensagem
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PesquisaProcesso))


// WEBPACK FOOTER //
// ./src/paginas/pesquisaprocesso/index.js